<template>
  <button type="button" class="tour-btn hv-btn" :class="{ 'tour-btn--compact': compact }" :aria-label="ariaLabel" @click="open">
    <span class="tour-btn__icon hv-btn__icon" aria-hidden="true">
      <i class="fas fa-circle-play"></i>
    </span>
    <span v-if="!compact" class="tour-btn__label">{{ label }}</span>
  </button>
</template>

<script>
// The way into a tutorial video from inside a tool, sitting next to the
// TourButton wherever there is one. Same pill, same two-tone blue — it
// borrows the .tour-btn rules outright rather than restating them, so the
// pair can't drift apart — with a play-circle in place of the question
// mark: the tour walks you through it here, the video shows you.
//
// Name a topic from src/data/videoHelp.js ('qpadm.sources'), which decides
// the video and the chapter it opens at, so the tool never carries a video
// id or a timestamp of its own. video-id / chapter / start are accepted too
// for a one-off. Opens the single GuideVideoModal mounted in App.vue.
// Positioning is the caller's business.
import topics from '@/data/videoHelp'
import { openVideoHelp } from '@/utils/guideVideos'

export default {
  name: 'HelpVideoButton',
  props: {
    topic: { type: String, default: '' },
    videoId: { type: String, default: '' },
    chapter: { type: String, default: '' },
    /** Seconds into the video to open at, when no chapter names it. */
    start: { type: Number, default: 0 },
    label: { type: String, default: 'Video' },
    compact: { type: Boolean, default: false },
  },
  computed: {
    target() {
      const t = (this.topic && topics[this.topic]) || {}
      if (this.topic && !topics[this.topic] && import.meta.env.DEV) console.warn('[HelpVideoButton] unknown topic:', this.topic)
      return {
        videoId: this.videoId || t.videoId || '',
        chapter: this.chapter || t.chapter || '',
        start: this.start || t.start || 0,
        context: this.topic || this.videoId,
      }
    },
    ariaLabel() {
      return this.target.chapter ? `Watch a video about ${this.target.chapter}` : 'Watch the video walkthrough'
    },
  },
  methods: {
    open() {
      if (!this.target.videoId) return
      openVideoHelp(this, this.target)
    },
  },
}
</script>

<style lang="scss">
.hv-btn .hv-btn__icon { font-size: 15px; }
</style>
